/**
 * ALL17 v košíku — tlačidlo z snippets/amh-all17.liquid uplatní kód jedným klikom.
 * Zapíše aj atribút košíka `_amh_all17 = tlacidlo` (prejde na objednávku, podľa neho sa meria účinok).
 * Košík sa kreslí v zásuvke aj na stránke a téma ho prekresľuje morphom, preto delegovaný klik na document.
 *
 * Po zmene kódu sa prekreslí len sekcia, v ktorej sa klikalo (rovnako ako pole „Rabat" v téme:
 * /cart/update.js so `sections` → morphSection + DiscountUpdateEvent). Zásuvka ostane otvorená,
 * stránka sa nenačítava znova. Znova sa načíta len keď prekreslenie zlyhá.
 */
(function () {
  "use strict";
  if (window.__amhAll17) return;
  window.__amhAll17 = true;

  /** Posledná príčina, prečo sa stránka načítala znova (sessionStorage amhAll17Err) — na ladenie. */
  function znova(why) { try { sessionStorage.setItem("amhAll17Err", String(why && (why.stack || why)).slice(0, 500)); } catch (_) {} location.reload(); }

  /**
   * Modul témy (@theme/…). Shopify pri minifikácii assetu prepíše import() na require(), ktoré v prehliadači
   * nie je (ReferenceError → stránka sa načítala znova a zásuvka sa zavrela). Cez Function to minifikátor nevidí.
   */
  var imp = Function("s", "return import(s)");

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; }

  function sekcia(el) {
    var s = el.closest(".shopify-section");
    return s && s.id ? s.id.replace(/^shopify-section-/, "") : null;
  }

  /** Zmení kódy (a prípadne atribúty) a prekreslí sekciu `sid`. Vráti odpoveď košíka. */
  function zmen(telo, sid) {
    if (sid) telo.sections = [sid];
    return fetch(root() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(telo),
    })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (cart) {
        var html = sid && cart.sections && cart.sections[sid];
        if (!html) { znova("bez html " + sid); return cart; }
        return Promise.all([imp("@theme/section-renderer"), imp("@theme/events")]).then(function (m) {
          document.dispatchEvent(new m[1].DiscountUpdateEvent(cart, "amh-all17"));
          m[0].morphSection(sid, html);
          return cart;
        }, function (er) { znova(er); return cart; });
      });
  }

  /**
   * Krížik na štítku zadaného kódu (cart-discount). Téma kód odoberá cez /cart/change.js bez riadku,
   * čo Shopify odmietne a kód ostane — doteraz to nebolo vidieť, štítok bol skrytý. Zachytí sa tu skôr
   * než v téme a kódy sa prepíšu cez /cart/update.js.
   */
  document.addEventListener("click", function (e) {
    var x = e.target.closest && e.target.closest(".cart-discount__pill-remove");
    if (!x) return;
    var pill = x.closest(".cart-discount__pill");
    var comp = x.closest("cart-discount-component") || document;
    if (!pill) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var zostanu = Array.prototype.map.call(comp.querySelectorAll(".cart-discount__pill"), function (p) { return p.getAttribute("data-discount-code"); })
      .filter(function (k) { return k && k !== pill.getAttribute("data-discount-code"); });
    x.disabled = true;
    zmen({ discount: zostanu.join(",") }, sekcia(x)).catch(znova);
  }, true);

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-amh-all17-apply]");
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest(".amh-all17");
    var err = box && box.querySelector(".amh-all17__err");
    var txt = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute("data-wait") || "…";
    zmen({ discount: "ALL17", attributes: { _amh_all17: "tlacidlo" } }, sekcia(btn))
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === "ALL17" && d.applicable; });
        if (!ok) throw new Error("not applicable");
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = txt;
        if (err) { err.textContent = btn.getAttribute("data-err") || ""; err.hidden = false; }
      });
  });
})();
